var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 11.73c0 .75-.62 1.34-1.32 1.34h-1.33l.03 6.67c0 .11-.01.23-.02.34v.68c0 .92-.74 1.67-1.67 1.67h-.67c-.05 0-.09 0-.14-.01-.06.01-.12.01-.18.01h-1.75c-.92 0-1.67-.75-1.67-1.67v-2.67c0-.74-.6-1.33-1.33-1.33h-2.67c-.74 0-1.33.6-1.33 1.33v2.67c0 .92-.75 1.67-1.67 1.67H7.07c-.06 0-.12 0-.19-.01-.05.01-.1.01-.15.01H6.07c-.92 0-1.67-.75-1.67-1.67v-4.67c0-.04 0-.08.01-.12v-2.91H3.08c-.75 0-1.33-.59-1.33-1.34 0-.38.13-.71.42-1L10.86.33C11.15.04 11.48 0 11.77 0s.63.08.88.29l10.64 9.35c.33.29.5.63.46 1.01z",
    transform: "translate(-1.75 2.5) scale(1.03)",
    fill: "#002d72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHealth);
export default __webpack_public_path__ + "static/media/home_health.2852db5a2c53bd34ba5ad9b4223e8f65.svg";
export { ForwardRef as ReactComponent };